export default (t) => [
  {
    text: t('Inventory'),
    value: 'name'
  },
  {
    text: t('Quantity'),
    value: 'quantity'
  },
  {
    text: t('Unit'),
    value: 'unit'
  }
];
